















































import { Vue, Component } from 'vue-property-decorator';
import DatePicker from '@/reusable/Form/DatePicker.vue';

import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';

import { fetchMS } from '@/pantallas/Conecta/Equipos/fetchMS';
import { ParamApi } from '@/pantallas/Conecta/Equipos/models/Equipos.model';

@Component({ components: { DatePicker } })
export default class EquiposFilter extends Vue {
  readonly loadingService: LoadingService = new LoadingService();
  readonly $snotify: Snotify = null;

  paramApi: ParamApi = {};

  startDateName: string = 'Fecha Creación Inicio';
  endDateName: string = 'Fecha Creación Fin';
  filterApi: any = {};

  async mounted() {
    await this.getFilters();
    this.handleFilters();
  }

  handleSearchFilter() {
    this.handleFilters();
  }

  handleCleanFilters() {
    this.paramApi = {};
    this.$emit('filters', {});
  }

  handleFilters() {
    const params = { ...this.paramApi };
    this.$emit('filters', params);
  }

  async getFilters() {
    try {
      this.loadingService.showLoading();
      const result = await fetchMS({ endpoint: 'get_filters' });
      const { MENSAJE_RESPUESTA, CODIGO_RESPUESTA, FILTERS } = result.data;
      if (Number(CODIGO_RESPUESTA) !== 1) {
        this.$snotify.error(MENSAJE_RESPUESTA);
        return;
      }
      this.filterApi = { ...FILTERS };
      console.log('async getFilters()', this.filterApi);
    } catch (error) {
      this.$snotify.error(
        'Ha ocurrido un error inesperado, por favor intente más tarde'
      );
    } finally {
      this.loadingService.hideLoading();
    }
  }
}
